import { memo } from "react";
import { useParams } from "react-router-dom";

// Sayısal görünen hücreler sağa yaslanır: 1.234,56  -12  %18  18 %
const NUMERIC = /^[-+]?\s?%?\s?[\d.,]+\s?%?$/;
// Toplam satırları vurgulanır
const TOTAL_ROW = /\b(toplam|total|genel)\b/i;

const cleanCell = (cell) => String(cell ?? "").replace(/¤/g, "");

/**
 * Rapor tablosu: başlık şeridi, sütun başlıkları, zebra satırlar, toplam satırı vurgusu,
 * sayısal hücreler sağda, adisyon numaraları tıklanabilir.
 */
const MyTable = ({
  table,
  showColumns = false,
  showTitle = true,
  className = "",
  showTickDetail,
}) => {
  const url = useParams()["*"];
  const columns = table.columns || [];
  const hasHeaders = columns.length > 0 && columns.some((c) => c.header);

  const renderCell = (cell) => {
    const text = cleanCell(cell);
    if (
      url !== "compare" &&
      showTickDetail &&
      (text.startsWith("🧾") || text.startsWith("#"))
    ) {
      const match = text.match(/\d+$/);
      if (match) {
        const number = parseInt(match[0], 10);
        return (
          <button
            type="button"
            className="inline-flex items-center rounded-md bg-[--primary] px-2 py-0.5 text-xs font-semibold text-white hover:bg-[--primary-hover]"
            onClick={() => showTickDetail(number)}
          >
            {text}
          </button>
        );
      }
    }
    return text;
  };

  return (
    <div
      className={`mb-3 rounded-xl bg-[--components-color] border border-solid border-[--gr-3] shadow-sm overflow-hidden ${className}`}
    >
      {showTitle && table.name && (
        <div className="px-6 py-1.5 bg-[--gr-1] border-0 border-b border-solid border-[--gr-3]">
          <h2 className="text-sm font-normal text-[--gr-9] text-center Poppins">
            {table.name}
          </h2>
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          {showColumns && hasHeaders && (
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    scope="col"
                    className={`px-4 py-2 text-xs font-semibold uppercase tracking-wider text-[--tx-3] bg-[--gr-0] whitespace-nowrap ${
                      index === columns.length - 1 && columns.length > 1
                        ? "text-right"
                        : "text-left"
                    }`}
                  >
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {table.rows.map((row, rowIndex) => {
              const cells = row.cells || [];
              const isTotal = TOTAL_ROW.test(cleanCell(cells[0]));
              return (
                <tr
                  key={rowIndex}
                  className={`border-0 border-b border-solid border-[--gr-2] last:border-b-0 ${
                    isTotal
                      ? "bg-[--gr-0] font-semibold"
                      : "odd:bg-[--btn-txt] even:bg-[--gr--0] hover:bg-[--gr-0]"
                  }`}
                >
                  {cells.map((cell, cellIndex) => {
                    const text = cleanCell(cell);
                    const numeric =
                      cells.length > 1 &&
                      (NUMERIC.test(text.trim()) ||
                        cellIndex === cells.length - 1);
                    return (
                      <td
                        key={cellIndex}
                        className={`px-4 py-2 whitespace-nowrap text-[--gr-9] ${
                          numeric ? "text-right tabular-nums" : "text-left"
                        }`}
                      >
                        {renderCell(cell)}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(MyTable);
